
<div :class="jel_getClassObject(content)">
  <div class="list-group">
    <!-- Titres du menu pied de page -->

    <div
      v-if="content.titre"
      :content="content.titre"
      class="liste-titre d-flex py-2 px-3 px-md-4"
      :class="[cssListGroupItem, jel_getClassObject(content)]"
      @click="isMenuPiedDePageOuvert = !isMenuPiedDePageOuvert"
    >
      <span class="p-0">
        {{ content.titre }}
      </span>
      <svg-icon
        class="d-md-none ml-auto mr-0"
        :class="{ rotation180: isMenuPiedDePageOuvert }"
        icon-name="fleche-bas"
      />
    </div>

    <WithRoot v-for="groupe in groupes" :key="groupe.id">
      <div class="col-12 p-0">
        <div class="w-100">
          <b-link
            v-if="content.montrerPlusMoins == 'true'"
            :key="groupe.listeItems[0].id"
            class="w-100"
            :class="[cssListGroupItem, jel_getClassObject(groupe.listeItems[0])]"
            v-bind="jel_getLienBinding(groupe.listeItems[0].lien)"
            @click="getPrefs(groupe.listeItems[0])"
          >
            <slot name="element" :itemElement="groupe.listeItems[0]"></slot>
          </b-link>
          <template
            v-if="
              (isMoreThanOneElement(groupe.listeItems) && isMenuGaucheOuvert) ||
              isMenuToutesCategories ||
              isMenuPiedDePage
            "
          >
            <template v-if="content.montrerPlusMoins == 'true'">
              <b-link
                v-for="itemElement in groupe.listeItems.slice(1, 4)"
                :key="itemElement.id"
                :class="[cssTitreElement, jel_getClassObject(itemElement)]"
                v-bind="jel_getLienBinding(itemElement.lien)"
              >
                <slot name="element" :itemElement="itemElement"></slot>
              </b-link>
              <b-collapse
                v-if="groupe.listeItems.length > 4"
                :id="`collapse-${groupe.listeItems[0]['@id']}`"
                :visible="getIsSectionMenuOuvert(groupe.listeItems[0]['@id'])"
              >
                <b-link
                  v-for="itemElement in groupe.listeItems.slice(4)"
                  :key="itemElement.id"
                  :class="[cssTitreElement, jel_getClassObject(itemElement.lien)]"
                  v-bind="jel_getLienBinding(itemElement.lien)"
                >
                  <slot name="element" :itemElement="itemElement"></slot>
                </b-link>
              </b-collapse>
            </template>
            <!-- Menu de pied de page -->
            <template v-else>
              <span @click.capture="gaPreventClick">
                <b-link
                  v-for="itemElement in groupe.listeItems"
                  :key="itemElement.id"
                  class="lien-bouton-menu"
                  :class="[cssListGroupItem, jel_getClassObject(itemElement)]"
                  v-bind="jel_getLienBinding(itemElement.lien)"
                >
                  <slot name="element" :itemElement="itemElement"></slot>
                </b-link>
              </span>
            </template>
          </template>
        </div>
        <button
          v-if="
            content.montrerPlusMoins == 'true' &&
            groupe.listeItems.length > 4 &&
            isMenuGaucheOuvert
          "
          :ref="`${groupe.listeItems[0]['@id']}`"
          class="col-12 montrer-plus-moins menu-ouvert"
          @click="setSectionMenuIsOuvert(`${groupe.listeItems[0]['@id']}`)"
        >
          <b-icon
            icon="chevron-down"
            aria-hidden="true"
            :class="{ rotation180: getIsSectionMenuOuvert(`${groupe.listeItems[0]['@id']}`) }"
          />
          <span class="sr-only">{{ $t('messageComponent.montrer') }}</span>
          {{
            getIsSectionMenuOuvert(groupe.listeItems[0]['@id'])
              ? $i18n.tc('messageComponent.plusMoins', 2)
              : $i18n.tc('messageComponent.plusMoins', 1)
          }}
          <span class="sr-only">
            {{ $t('messageComponent.de') }} {{ groupe.listeItems[0].item }}
          </span>
        </button>
      </div>
    </WithRoot>
  </div>
</div>
